import React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import { NotFound, ReservationPhoto } from "../views";
import { CreateNewPassword, EnterEmail, LoginContainer, LogoutContainer } from "../views/User";
import FleetRouter from "./FleetRouter";
import DeploymentRouter from "./DeploymentRouter";
import RiderRouter from "./RiderRouter";
import PromosRouter from "./PromosRouter";
import PermissionedRoute from "./PermissionedRoute";
import Permissions from "../permissions";
import VehicleRouter from "./VehicleRouter";
import { FleetSettingsState } from "../context";

export const Router = () => {
  const location = useLocation();

  return (
    <Switch>
      <Redirect // redirect all routes to have no trailing slash
        from="/:url*(/+)"
        to={location.pathname.slice(0, -1)}
      />
      <Route // redirect all routes to lowercase
        sensitive
        path="/:slug1*:slug2([A-Z]):slug3*/"
      >
        <Redirect to={`${location.pathname.toLowerCase()}`} />
      </Route>
      <Route exact path="/">
        <Redirect to="/fleets" />
      </Route>
      <Route path="/login">
        <LoginContainer />
      </Route>
      <Route path="/logout">
        <LogoutContainer />
      </Route>
      <Route exact path="/reset-password">
        <EnterEmail />
      </Route>
      <Route path="/reset-password/:token">
        <CreateNewPassword />
      </Route>
      <Route path="/fleets">
        <FleetRouter />
      </Route>
      <Route path="/deployment">
        <DeploymentRouter />
      </Route>
      <Route path="/riders">
        <FleetSettingsState>
          <RiderRouter />
        </FleetSettingsState>
      </Route>
      <Route path="/vehicles">
        <VehicleRouter />
      </Route>
      <Route path={["/promos", "/promo-groups"]}>
        <PromosRouter />
      </Route>
      <PermissionedRoute
        path="/reservation-photo/:reservationId"
        permission={Permissions.readReservations}
      >
        <ReservationPhoto />
      </PermissionedRoute>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
};

export default Router;
